import { useMemo, useState } from 'react'
import classNames from 'classnames'
import { some } from 'lodash'
import { useTranslation } from 'react-i18next'
import CompanyBrandingTab from 'pages/company/CompanyBrandingTab'
import CompanyDnsTab from 'pages/company/CompanyDnsTab'

const CompanyEcommerceTab = ({ companyId, companyData, refetch, dnsEditLocked, canBranding, canDns, initialSection }) => {
  const { t } = useTranslation()

  const subTabs = useMemo(
    () => [...(canBranding ? [{ id: 'branding', name: t('companyProfile.tabs.branding') }] : []), ...(canDns ? [{ id: 'dns', name: t('companyProfile.tabs.dnsManagement') }] : [])],
    [canBranding, canDns, t]
  )

  const resolvedInitialSection = some(subTabs, { id: initialSection }) ? initialSection : subTabs[0]?.id
  const [activeSection, setActiveSection] = useState(resolvedInitialSection)

  if (!subTabs.length) return null

  return (
    <div className="flex flex-col sm:flex-row sm:items-start">
      {subTabs.length > 1 ? (
        <nav className="w-full shrink-0 border-b border-gray-200 bg-white sm:w-56 sm:border-b-0 sm:border-r lg:w-64" aria-label={t('companyProfile.tabs.ecommerce')}>
          {subTabs.map(tab => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveSection(tab.id)}
              className={classNames(
                'flex w-full items-center px-5 py-4 text-left text-sm font-medium transition-colors',
                tab.id === activeSection
                  ? 'border-l-2 border-indigo-500 bg-gray-50 text-indigo-600'
                  : 'border-l-2 border-transparent text-gray-600 hover:bg-gray-50 hover:text-gray-900'
              )}
              aria-current={tab.id === activeSection ? 'page' : undefined}
            >
              <span className="truncate">{tab.name}</span>
            </button>
          ))}
        </nav>
      ) : null}

      <div className="min-w-0 flex-1">
        {activeSection === 'branding' && canBranding ? (
          <CompanyBrandingTab companyId={companyId} companyData={companyData} refetch={refetch} dnsEditLocked={dnsEditLocked} />
        ) : null}

        {activeSection === 'dns' && canDns ? <CompanyDnsTab companyId={companyId} companyData={companyData} refetch={refetch} /> : null}
      </div>
    </div>
  )
}

export default CompanyEcommerceTab
